import React, { useEffect, useState } from "react";
import { Modal, notification } from "antd";
import "../IntroForm/introForm.scss";
import axios from "axios";
import Lottie from "lottie-react";
// import successAnim from "./path-to-your-lottie/success.json";

const IntroForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    ndaChecked: false,
    aboutProject: "",
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    nda: "",
    aboutProject: "",
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const validateForm = () => {
    let valid = true;
    const errors = {
      name: "",
      email: "",
      phoneNumber: "",
      nda: "",
      aboutProject: "",
    };

    if (!formData.name.trim()) {
      valid = false;
      errors.name = "Please enter your name.";
    }

    if (!formData.email.trim()) {
      valid = false;
      errors.email = "Please enter your email.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        valid = false;
        errors.email = "Please enter a valid email address.";
      }
    }

    if (!formData.phoneNumber.trim()) {
      valid = false;
      errors.phoneNumber = "Please enter your phone number.";
    } else {
      const phoneNumberRegex = /^\d{10}$/;
      if (!phoneNumberRegex.test(formData.phoneNumber)) {
        valid = false;
        errors.phoneNumber = "Please enter a valid 10-digit phone number.";
      }
    }

    if (!formData.aboutProject.trim()) {
      valid = false;
      errors.aboutProject = "Please enter meassage";
    }

    if (!formData.ndaChecked) {
      valid = false;
      errors.nda = "Please agree to the NDA terms.";
    }

    setFormErrors(errors);
    return valid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axios.post(
        "https://brandcraftcreative.com/enquiry.php",
        formData
      );

      if (response.status >= 200 && response.status < 300) {
        notification.success({ message: "Form submitted successfully" });
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          ndaChecked: false,
          aboutProject: "",
        });

        setFormErrors({
          name: "",
          email: "",
          phoneNumber: "",
          nda: "",
          aboutProject: "",
        });

        setIsFormSubmitted(true);
      } else {
        notification.error({ message: "Submission failed. Please try again." });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setFormErrors(error.response.data.errors);
      } else {
        notification.error({ message: "Error submitting form." });
        console.error("Error submitting form:", error);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneNumberChange = (event) => {
    const inputPhoneNumber = event.target.value;
    const sanitizedPhoneNumber = inputPhoneNumber.replace(/[^0-9]/g, "");
    setFormData((prevData) => ({
      ...prevData,
      phoneNumber: sanitizedPhoneNumber,
    }));
  };

  const handleTextareaChange = (event) => {
    const textareaLineHeight = 2;
    const minRows = 1;

    event.target.style.height = "auto";

    const currentHeight = event.target.scrollHeight;
    const minHeight = textareaLineHeight * minRows;

    event.target.style.height = `${Math.max(currentHeight, minHeight)}px`;

    setFormData((prevData) => ({
      ...prevData,
      aboutProject: event.target.value,
    }));
  };

  // if (isFormSubmitted) {
  //   return (
  //     <div>
  //         <div className="overlayBgMsg"></div>
  //         <div className="successMessage">
  //           <div className="animDiv">
  //             <Lottie options={defaultOptions} className="animeGIf" />
  //           </div>
  //           <h3 className="successMsgText">{successMessage}</h3>
  //           <button onClick={handleCloseForm} className="closPopBtn">
  //             <i className="fa fa-close"></i>
  //           </button>
  //         </div>
  //       </div>
  //   );
  // }

  //   {isFormSubmitted && (
  //   <div className="success-overlay">
  //     <Lottie animationData={successAni} className="success-lottie" />
  //     <h3>Thanks for reaching out!</h3>
  //     <p>Our team will be in touch very soon 🚀</p>
  //     <button onClick={onClose}>Back to Site</button>
  //   </div>
  // )}

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      className="intro-call-modal"
      maskClosable={false}
      getContainer={false}
    >
      {/* <h2>
        <strong>
          Start <span className="highlight">growing</span>
        </strong>{" "}
        your business with us
      </h2> */}

      <form
        key={isFormSubmitted ? "submitted" : "unsubmitted"}
        onSubmit={handleSubmit}
      >
        <div className="form-row">
          <input
            type="text"
            placeholder="Name*"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
          {formErrors.name && (
            <span className="errorMessage">{formErrors.name}</span>
          )}

          <input
            type="email"
            placeholder="Email*"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          {formErrors.email && (
            <span className="errorMessage">{formErrors.email}</span>
          )}

          <input
            type="tel"
            placeholder="Phone Number*"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handlePhoneNumberChange}
          />
          {formErrors.phoneNumber && (
            <span className="errorMessage">{formErrors.phoneNumber}</span>
          )}
        </div>

        <textarea
          placeholder="Message*"
          name="aboutProject"
          value={formData.aboutProject}
          onChange={handleTextareaChange}
        />
        {formErrors.aboutProject && (
          <span className="errorMessage">{formErrors.aboutProject}</span>
        )}

        <div className="captcha-placeholder">
          <input
            type="checkbox"
            id="robot"
            checked={formData.ndaChecked}
            onChange={(e) =>
              setFormData((prevData) => ({
                ...prevData,
                ndaChecked: e.target.checked,
              }))
            }
          />

          <label htmlFor="robot">I'm not a robot</label>
        </div>

        <button type="submit" className="send-message-btn">
          Send Message
        </button>
        {/* <p className="privacy-text">
          By sending this NDA form I confirm that I have read and accept the{" "}
          <a href="#">Privacy Policy</a>
        </p> */}
      </form>
    </Modal>
  );
};

export default IntroForm;
